import { Smartphone, Leaf, Zap } from 'lucide-react';
import './Highlights.css';

export default function Highlights() {
  const highlights = [
    {
      icon: Smartphone,
      title: 'Mobile Based Olympiad Tests',
      desc: 'Take exams seamlessly from your mobile device, anywhere and anytime.'
    },
    {
      icon: Leaf,
      title: 'Environment Friendly',
      desc: '100% paper-less and wire-less process, contributing to a greener planet.'
    },
    {
      icon: Zap,
      title: 'Zero Bottlenecks',
      desc: 'No infrastructure or power dependencies, ensuring uninterrupted assessments.'
    }
  ];

  return (
    <section className="highlights-section section-padding">
      <div className="container">
        <div className="section-header text-center">
          <h2 className="section-title" style={{ width: '100%' }}>Pioneering Modern Assessments</h2>
        </div>
        <div className="highlights-grid">
          {highlights.map((item, idx) => (
            <div key={idx} className="highlight-card glass-panel">
              <div className="highlight-icon-wrapper">
                <item.icon size={36} className="highlight-icon" />
              </div>
              <h3 className="highlight-title">{item.title}</h3>
              <p className="highlight-desc">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
